import { WarningCircle } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import type { ReactNode } from "react"

type GeneralErrorProps = {
  children?: ReactNode
}

export function GeneralError({ children }: GeneralErrorProps) {
  return (
    <div className="flex flex-col gap-6 items-center justify-center h-full">
      <Icon as={WarningCircle} width={32} />
      <div className="flex flex-col gap-4 items-center">
        Something went wrong
        <div className="text-sm text-fg-secondary">
          Go back or contact support if the problem persists.
        </div>
        {children}
      </div>
    </div>
  )
}
